<template>
  <v-container fluid class="investjournal-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Journal</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Journal</p>
                        <v-select
                          class="mb-4"
                          :items=journaltype
                          v-model="new_journal.journaltype"
                          v-bind:error="error == 'journaltype'"
                          v-on:change="clearFields(); clearTransactions()"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the journal type">
                        </v-select>
                        <v-menu
                          ref="menu_journaldate"
                          v-model="menu_journaldate"
                          :close-on-content-click="false"
                          :return-value.sync="new_journal.journaldate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_journal.journaldate"
                              v-on:change="onChangeJournalDate($event)"
                              label="Journal Date"
                              v-bind="attrs"
                              v-bind:value="new_journal.journaldate"
                              v-bind:error="error == 'journaldate'"
                              v-on="on"
                              single-line hint="Please choose the journal date"
                              persistent-hint
                              >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_journal.journaldate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_journaldate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="onChangeJournalDate(new_journal.journaldate); $refs.menu_journaldate.save(new_journal.journaldate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-menu
                          ref="menu_journalstartdate"
                          v-model="menu_journalstartdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_journal.journalstartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_journal.journalstartdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="new_journal.journalstartdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the start date"
                              persistent-hint
                              >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_journal.journalstartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_journalstartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_journalstartdate.save(new_journal.journalstartdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_journalenddate"
                          v-model="menu_journalenddate"
                          :close-on-content-click="false"
                          :return-value.sync="new_journal.journalenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              v-model="new_journal.journalenddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="new_journal.journalenddate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the end date"
                              persistent-hint
                              >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_journal.journalenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_journalenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_journalenddate.save(new_journal.journalenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="data_funds"
                          v-model="new_journal.fundid"
                          v-bind:error="error == 'fundid'"
                          outlined
                          dense
                          placeholder="Investment Fund"
                          persistent-hint
                          single-line hint="Enter the investment fund">
                        </v-select>
                        <v-textarea
                          v-model="new_journal.journalnote"
                          outlined
                          dense
                          rows=1
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>   
                      </v-form>
                    </v-col>                            
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/investjournal/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkJournal">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true; new_transaction= {}">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-data-table
                          :headers="header_items"
                          :items="transactions"
                          :items-per-page="500"
                          :footer-props="footer"
                          class="elevation-0"
                        >
                          <template v-slot:item.debit_accountid="{ item }">
                            <p class="two-line">{{ accounts.length>0 ? accounts.find(i=>i._id == item.debit_accountid)['accountname'] : '' }} (Receiving)</p>
                            <p class="two-line">{{ accounts.length>0 ? accounts.find(i=>i._id == item.credit_accountid)['accountname'] : '' }} (Deducting)</p>
                          </template>
                          <template v-slot:item.transdate="{ item }">
                            <p class="two-line">{{ item.transtype }}</p>
                            <p class="two-line">{{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}</p>
                          </template>
                          <template v-slot:item.stockid="{ item }">
                            <div v-if="item.stockid!=null">{{ stocks.length>0 ? stocks.find(i=>i._id == item.stockid)['stockcode'] : '' }}</div>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="editTransactionDialog(item)">
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="deleteTransaction(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="1==0"
                          class="button-shadow"
                          color="primary"
                          @click="step = 3">
                          Next
                        </v-btn>
                        <v-btn
                          v-else
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertJournal()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="transtypes"
                    v-model="new_transaction.transtype"
                    v-on:change="onChangeType($event, 'add')"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Select the type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="transdesc[ new_transaction.transtype ]"
                    v-model="new_transaction.transdesc"
                    v-bind:error="errorindex == 12"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Select the description">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu
                    ref="menu_transdate"
                    v-model="menu_transdate"
                    :close-on-content-click="false"
                    :return-value.sync="new_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-model="new_transaction.transdate"
                        label="Date"
                        v-bind="attrs"
                        v-bind:value="new_transaction.transdate"
                        v-bind:error="errorindex == 13"
                        v-on="on"
                        single-line hint="Transaction Date"
                        persistent-hint
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="new_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menu_transdate = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu_transdate.save(new_transaction.transdate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                   :disabled="new_transaction.transtype!=null ? !transconfig[new_transaction.transtype]['isPrc'] : true"
                    type="number"
                    v-model="new_transaction.transprice"
                    v-on:input="onChangeQuantity('add')"
                    v-bind:error="errorindex == 14"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Prc"
                    persistent-hint
                    single-line hint="Price">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :disabled="new_transaction.transtype!=null ? !transconfig[new_transaction.transtype]['isQty'] : true"
                    type="number"
                    v-model="new_transaction.transquantity"
                    v-on:input="onChangeQuantity('add')"
                    v-bind:error="errorindex == 15"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Qty"
                    persistent-hint
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.transamount"
                    v-bind:error="errorindex == 16"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <v-select
                    class="mb-4"
                    :items="stocks.map(x => {
                        return {text: x.stockcode, value: x._id};
                    })"
                    :disabled="new_transaction.transtype!=null ? !transconfig[new_transaction.transtype]['isStock'] : true"
                    v-model="new_transaction.stockid"
                    v-bind:error="errorindex == 17"
                    outlined
                    dense
                    placeholder="Stock"
                    persistent-hint
                    single-line hint="Stock">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    :readonly="true"
                    class="mb-4"
                    :items="accounts.map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.debit_accountid"
                    v-bind:error="errorindex == 18"
                    outlined
                    dense
                    placeholder="Receiving Account"
                    persistent-hint
                    single-line hint="Receiving Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    :readonly="true"
                    class="mb-4"
                    :items="accounts.map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.credit_accountid"
                    v-bind:error="errorindex == 19"
                    outlined
                    dense
                    placeholder="Deducting Account"
                    persistent-hint
                    single-line hint="Deducting Account">
                  </v-select>
                </v-col>

                
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}; errorindex=0"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="transtypes"
                    v-model="edit_transaction.transtype"
                    v-on:change="onChangeType($event, 'edit')"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Select the type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="transdesc[ edit_transaction.transtype ]"
                    v-model="edit_transaction.transdesc"
                    v-bind:error="errorindex == 12"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Select the description">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu
                    ref="menu_transdate_edit"
                    v-model="menu_transdate_edit"
                    :close-on-content-click="false"
                    :return-value.sync="edit_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-model="edit_transaction.transdate"
                        label="Date"
                        v-bind="attrs"
                        v-bind:value="edit_transaction.transdate"
                        v-bind:error="errorindex == 13"
                        v-on="on"
                        single-line hint="Transaction Date"
                        persistent-hint
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menu_transdate_edit = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu_transdate_edit.save(edit_transaction.transdate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                   :disabled="edit_transaction.transtype!=null ? !transconfig[edit_transaction.transtype]['isPrc'] : true"
                    type="number"
                    v-model="edit_transaction.transprice"
                    v-on:input="onChangeQuantity('edit')"
                    v-bind:error="errorindex == 14"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Prc"
                    persistent-hint
                    single-line hint="Price">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :disabled="edit_transaction.transtype!=null ? !transconfig[edit_transaction.transtype]['isQty'] : true"
                    type="number"
                    v-model="edit_transaction.transquantity"
                    v-on:input="onChangeQuantity('edit')"
                    v-bind:error="errorindex == 15"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Qty"
                    persistent-hint
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.transamount"
                    v-bind:error="errorindex == 16"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <v-select
                    class="mb-4"
                    :items="stocks.map(x => {
                        return {text: x.stockcode, value: x._id};
                    })"
                    v-model="edit_transaction.stockid"
                    v-bind:error="errorindex == 17"
                    outlined
                    dense
                    placeholder="Stock"
                    persistent-hint
                    single-line hint="Stock">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    :readonly="true"
                    class="mb-4"
                    :items="accounts.map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.debit_accountid"
                    v-bind:error="errorindex == 18"
                    outlined
                    dense
                    placeholder="Receiving Account"
                    persistent-hint
                    single-line hint="Receiving Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    :readonly="true"
                    class="mb-4"
                    :items="accounts.map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.credit_accountid"
                    v-bind:error="errorindex == 19"
                    outlined
                    dense
                    placeholder="Deducting Account"
                    persistent-hint
                    single-line hint="Deducting Account">
                  </v-select>
                </v-col>

                
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}; errorindex=0"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { sortDataAsc } from '../../../util/tools';
import { getFirstDay, getLastDay } from "../../../util/tools";
import router from '@/Routes';

export default {
  data () {
    return {
      header_items: [
        { text: 'Type & Date', value: 'transdate', width: '10%'},
        { text: 'Account', value: 'debit_accountid', width: '30%'},
        { text: 'Description', value: 'transdesc'},
        { text: 'Stock', value: 'stockid', width: '8%'},
        { text: 'Prc', value: 'transprice', width: '8%'},
        { text: 'Qty', value: 'transquantity', width: '8%'},
        { text: 'Amt', value: 'transamount', width: '8%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      transtypes: ['Deposit', 'Withdrawl', 'Purchase', 'Sale', 'Dividend', 'Interest', 'Margin', 'Transfer In', 'Transfer Out'],
      transdesc: {
        'Deposit': ['Transfer from Bank'],
        'Withdrawl': ['Transfer to Bank'],
        'Purchase': ['Buy Stock'],
        'Sale': ['Sell Stock'],
        'Dividend': ['Qualified Dividend', 'Non-Qualified Dividend', 'Cash Dividend'],
        'Interest': ['Bank Interest'],
        'Margin': ['Margin Interest'],
        'Transfer In': ['Transfer In Stock'],
        'Transfer Out': ['Transfer Out Stock'],
      },
      transconfig: {
        'Deposit': {isStock: false, isQty: false, isPrc: false},
        'Withdrawl': {isStock: false, isQty: false, isPrc: false},
        'Purchase': {isStock: true, isQty: true, isPrc: true},
        'Sale': {isStock: true, isQty: true, isPrc: true},
        'Dividend': {isStock: true, isQty: false, isPrc: false},
        'Interest': {isStock: false, isQty: false, isPrc: false},
        'Margin': {isStock: false, isQty: false, isPrc: false},
        'Transfer In': {isStock: true, isQty: true, isPrc: true},
        'Transfer Out': {isStock: true, isQty: true, isPrc: true},
      },


      step: 1,
      new_journal: {},
      new_transaction: {},
      edit_transaction: {},
      transactions: [],
      journaltype: ['Investment Journal', 'Monthly Statement'],

      isAddTransaction: false,
      isEditTransaction: false,
      menu_journaldate: false,
      menu_journalstartdate: false,
      menu_journalenddate: false,
      menu_transdate: false,
      menu_transdate_edit: false,

      error: null,
      errorindex: null,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('InvestJournal', ['investjournals', 'isReceiving']),
    ...mapState('InvestFund', ['funds']),
    ...mapState('InvestStock', ['stocks']),
    ...mapState('SystemSetting', ['settings']),
    data_funds(){
      return this.funds.map(x => { return {text: x.fundname, value: x._id} });
    },
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('InvestJournal', ['insertInvestJournalRequest', 'insertInvestJournalRequest']),
    ...mapActions('InvestFund', ['getInvestFundsRequest']),
    ...mapActions('InvestStock', ['getInvestStocksRequest']),
    ...mapActions('SystemSetting', ["getSetting"]),
    checkJournal(){
      if(!this.new_journal.journaltype){
        this.haserrors = true;
        this.error = 'journaltype';
        return false;
      }
      if(!this.new_journal.journaldate){
        this.haserrors = true;
        this.error = 'journaldate';
        return false;
      }
      if(!this.new_journal.fundid){
        this.haserrors = true;
        this.error = 'fundid';
        return false;
      }
      this.error = null;
      this.step = 2;
      return true;
    },
    checkTransaction(transaction){
      if(!transaction.transtype){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!transaction.transdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!transaction.transdate){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      if(this.transconfig[transaction.transtype].isPrc==true &&  !transaction.transprice){
        this.haserrors = true;
        this.errorindex = 14;
        return false;
      }
      if(this.transconfig[transaction.transtype].isPrc==true &&  !transaction.transquantity){
        this.haserrors = true;
        this.errorindex = 15;
        return false;
      }
      if(!transaction.transamount){
        this.haserrors = true;
        this.errorindex = 16;
        return false;
      }
      if(this.transconfig[transaction.transtype].isStock==true &&  !transaction.stockid){
        this.haserrors = true;
        this.errorindex = 17;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    addTransaction(){
      if(!this.checkTransaction(this.new_transaction)) return;
      let trans = Object.assign({}, this.new_transaction, {id: Math.floor(Math.random() * Math.pow(10, 10))});
      this.transactions.push(trans);
      this.clearFields();
      this.isAddTransaction = false;
    },
    clearFields(){
      this.new_transaction = {};
    },
    clearStockFields(route){
      console.log(route)
      if(route=='edit') this.edit_transaction = Object.assign(this.edit_transaction, {stockid: null, transprice: null, transquantity: null});
      else this.new_transaction = Object.assign(this.new_transaction, {stockid: null, transprice: null, transquantity: null});
      console.log(this.new_transaction)
    },
    clearTransactions(){
      this.transactions = [];
    },
    async insertJournal() {
      if(this.transactions==null || this.transactions.length==0) return;
      let payload = {journal: this.new_journal, transactions: this.transactions};
      await this.insertInvestJournalRequest(payload);
      router.push('/investjournal/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans) => trans.id == item.id);      
      if(index!=-1) this.transactions.splice(index,1);
    },
    editTransactionDialog(item){
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      if(!this.checkTransaction(this.edit_transaction)) return;
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    onChangeType(type, route){
      this.getAccount(type, route);
    },
    onChangeJournalDate(value) {
      let date = new Date(value);
      let start_date = getFirstDay(date);
      let end_date = getLastDay(date);
      this.new_journal = Object.assign(this.new_journal, {journalstartdate: start_date, journalenddate: end_date});
    },
    onChangeQuantity(route){
      let update = {};
      
      if(route=='edit') {
        if(!this.edit_transaction.transquantity && !this.edit_transaction.transquantity) return;
        update.transamount =  this.edit_transaction.transquantity * this.edit_transaction.transprice;
        this.edit_transaction = Object.assign(this.edit_transaction, update);
      }
      else {
        if(!this.new_transaction.transquantity && !this.new_transaction.transquantity) return;
        update.transamount =  this.new_transaction.transquantity * this.new_transaction.transprice;
        this.new_transaction = Object.assign(this.new_transaction, update);
      }
    },
    getAccount(type, route){
      let result = {};
      let fund = this.funds.find(i=>i._id==this.new_journal.fundid);
      if(type=='Deposit'){
        result.debit_accountid = fund.cash_accountid;
        result.credit_accountid = fund.bank_accountid;
        this.clearStockFields(route);
      }
      if(type=='Withdrawl'){
        result.debit_accountid = fund.bank_accountid;
        result.credit_accountid = fund.cash_accountid;
        this.clearStockFields(route);
      }
      if(type=='Purchase'){
        result.debit_accountid = fund.asset_accountid;
        result.credit_accountid = fund.cash_accountid;
      }
      if(type=='Sale'){
        result.debit_accountid = fund.cash_accountid;
        result.credit_accountid = fund.asset_accountid;
      }
      if(type=='Dividend'){
        result.debit_accountid = fund.cash_accountid;
        result.credit_accountid = fund.dividend_accountid;
      }
      if(type=='Interest'){
        result.debit_accountid = fund.cash_accountid;
        result.credit_accountid = fund.interest_accountid;
        this.clearStockFields(route);
      }
      if(type=='Margin'){
        result.debit_accountid = fund.expense_accountid;
        result.credit_accountid = fund.cash_accountid;
      }
      if(type=='Transfer In'){
        result.debit_accountid = fund.asset_accountid;
        result.credit_accountid = null
      }
      if(type=='Transfer Out'){
        result.credit_accountid = fund.asset_accountid;
        result.debit_accountid = null
      }
      if(route=='edit' )this.edit_transaction = Object.assign(this.edit_transaction, result);
      else this.add_transaction = Object.assign(this.new_transaction, result);
    }
  },

  async created () {
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.funds.length==0) await this.getInvestFundsRequest();
    if(this.stocks.length==0) await this.getInvestStocksRequest();
    sortDataAsc(this.funds, 'fundrank');
    sortDataAsc(this.stocks, 'stockcode');


  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
